import { cache } from "react";

// Cached product data
export const getProducts = cache(() => [
  {
    id: "1",
    imageSrc: "/images/breatheTea25g.webp",
    tagline: "Supports respiratory health & soothes the chest",
    title: "Breathe Tea - Chest & Airway Herbal Tea",
    size: "25g",
    slug: "breathe-tea",
    metaDescription: "A warming herbal tea to soothe the chest and open the airways. Caffeine-free, 100% herbal and gentle enough for up to three cups a day. 25g, \u00a310.",
    price: "£10.00 GBP",
    badge: "",
    tags: ["Sleep", "Gut Health"],
    trust: [{label:'Supports Clear Breathing'}, {label:'Soothes & Opens Airways'}, {label:'100% Herbal & Caffeine-free'}],
    directions: "Steep in freshly boiled water for at least 2 minutes. For a stronger brew, let steep longer and inhale the steam before sipping. Enjoy up to 3 cups daily.",
    ingredients: "",
    nutritional: "",
    description:
      "Breathe Easy Tea is a warming herbal blend specially formulated to soothe the chest, open the airways, and support comfortable, easy breathing. Whether you're dealing with seasonal congestion, a persistent cough, or simply want to support your respiratory health as part of your daily wellness routine, this tea provides gentle, natural relief. Comforting to drink, naturally caffeine-free, and crafted with care from carefully selected herbs.",
    who: "Anyone prone to seasonal coughs or congestion, Those looking to support lung and respiratory health naturally, People who want a warming caffeine-free alternative to regular tea, Anyone recovering from a cold or chest discomfort",
    faq: [
      {
        question: "What does Breathe Easy Tea help with?",
        answer: "Breathe Easy Tea is designed to soothe the chest, open the airways, and provide gentle respiratory support. It's ideal for times of seasonal congestion, coughs, or general chest tightness — or simply as a warming daily ritual to keep your breathing comfortable.",
      },
      {
        question: "Can I drink it every day?",
        answer: "Yes — up to 3 cups daily is perfectly fine. Many people enjoy it as a morning ritual or before bed to support relaxed, open breathing overnight.",
      },
      {
        question: "Is it caffeine-free?",
        answer: "Completely. Breathe Easy Tea is 100% herbal and naturally caffeine-free, making it suitable any time of day, including evenings.",
      },
      {
        question: "How do I get the most out of it?",
        answer: "Steep for at least 2 minutes in freshly boiled water. For a stronger effect, steep longer and inhale the steam gently before sipping — the aromatic steam itself provides comfort and supports easier breathing.",
      },
    ],
  },
  {
    id: "2",
    imageSrc: "/images/bentoniteClay250g.webp",
    title: "Bentonite Clay - Detox Bath & Face Mask",
    tagline: "Deep-cleansing clay for bath or mask — draws out impurities naturally",
    size: "250g",
    slug: "bentonite-clay",
    faq: [
      {
        question: "How do I use Bentonite Clay?",
        answer: "Two ways. As a bath soak, add a few tablespoons to warm bath water and soak for 20–30 minutes. As a face mask, mix the clay with water or herbal tea to make a paste, apply to clean skin and leave for 10–15 minutes before rinsing.",
      },
      {
        question: "Why can't I use metal utensils with it?",
        answer: "Metal can react with the clay's natural properties and reduce how well it works. Always use plastic or wooden utensils to scoop and mix it.",
      },
      {
        question: "What's actually in it?",
        answer: "One ingredient — 100% natural mineral clay. Nothing added. The tub is 250g, which goes a long way whether you're using it for baths or masks.",
      },
    ],
    metaDescription: "100% natural mineral clay for a detox bath or purifying face mask \u2014 draws impurities out through the skin and supports clearer skin. 250g, \u00a315.",
    who: "Anyone wanting a detox bath as part of a cleanse, Those looking for a natural purifying face mask, People supporting the body's detox pathways through the skin, Anyone who prefers a single-ingredient natural mineral product",
    price: "£15.00 GBP",
    tags: ["Detox"],
    trust: [{label: "Detox Bath or Face Mask"}, {label: "Draws Out Impurities"}, {label: "100% Natural Mineral Clay"}],
    directions: "Bath soak: Add a few tablespoons to warm bath water and soak for 20–30 minutes. Face mask: Mix clay with water or herbal tea to form a paste. Apply to clean skin and leave for 10–15 minutes before rinsing. ⚠️ Important: Always use plastic or wooden utensils to handle this clay. Metal can react with its natural properties and reduce effectiveness.",
    ingredients: "100% natural mineral bentonite clay. Nothing added.",
    nutritional: "",
    description:
      "This powerful detox clay is designed to help draw out toxins, heavy metals, and impurities from the body through the skin. Ideal for use in detox baths or as a purifying face mask, it supports clearer skin, improved circulation, and overall wellness. Use this clay as part of your self-care routine to promote deep cleansing and skin health—naturally.",
  },
  {
    id: "3",
    imageSrc: "/images/chilliTea25g.webp",
    title: "Chill Tea - Organic Sleep & Calm Tea",
    size: "25g",
    slug: "chill-tea",
    faq: [
      {
        question: "What's in Chill Tea?",
        answer: "A blend of organic passionflower, rose, vervain, betony, chamomile and skullcap. Nothing else.",
      },
      {
        question: "Is it caffeine-free?",
        answer: "Yes — completely caffeine-free and 100% organic, so it's suitable in the evening or any time you want to slow down.",
      },
      {
        question: "How do I brew it?",
        answer: "Steep 1–2 teaspoons in hot water for 5–10 minutes, then sip slowly and let the herbs do their work.",
      },
      {
        question: "When is the best time to drink it?",
        answer: "Most people use it in the evening to wind down, but it's just as useful in the middle of a stressful day when you need to reset.",
      },
    ],
    metaDescription: "An organic, caffeine-free blend of passionflower, chamomile, rose and skullcap to quiet a racing mind and ease you into restful sleep. 25g, \u00a310.",
    who: "Anyone struggling to quiet a racing mind at bedtime, Those winding down after a busy or stressful day, People who want a caffeine-free evening ritual, Anyone wanting an organic herbal tea for the evening",
    tagline: "Organic calm in a cup — ease into deep, restful sleep",
    price: "£10.00 GBP",
    tags: ["Sleep", "Hormones"],
    trust: [{label: "Supports Restful Sleep"}, {label: "Calms a Busy Mind"}, {label: "Caffeine-free * 100% Organic"}],
    directions: "Steep 1–2 teaspoons in hot water for 5–10 minutes. Sip slowly and let the calming herbs do their work. 🌿 100% organic ingredients 🫖 Naturally caffeine-free 🌙 Ideal for evening use or during times of stress",
    ingredients: "Organic Passionflower, Organic Rose, Organic Vervain, Organic Betony, Organic Chamomile, Organic Skullcap.",
    nutritional: "",
    description:
      "Unwind naturally with our Sleep & Soothe Herbal Tea, a calming, caffeine-free blend crafted to support deep relaxation and restful sleep. Whether you're winding down after a busy day or struggling to quiet a racing mind, this gentle herbal tea helps ease you into a state of calm. Made with a soothing mix of organic passionflower, rose, vervain, betony, chamomile, and skullcap, this blend is perfect for bedtime or any time you need to relax and reset.",
},
  {
    id: "4",
    imageSrc: "/images/blogs/GutBusterNew.webp",
    title: "Gut Buster - Natural Gut & Bloat Support",
    size: "100 Capsules",
    price: "£30.00 GBP",
    slug: "gut-buster",
    metaDescription: "Gut Buster capsules soften and move built-up sediment in the gut \u2014 supporting regular bowel movements and easing bloating naturally. 50-day supply.",
    badge: "Hot Item",
    tagline: "Gentle daily support for regularity, less bloat, and a happier gut",
    tags: ["Gut Health", "Detox"],
    trust: [{label: "Supports healthy digestion"}, {label: "Eases bloating naturally"}, {label: "Encourages regular bowel movement"}],
    directions: "Everyone is different. Start with 2x capsules with your evening meal or before bed. Observe the next day for ‘some great news’. If there is no ‘news’, move to 3x capsules the following evening. Continue increasing until the desired ‘news’ arrives in the morning!",
    ingredients: "Aloe Cupensis (Cape Aloes - calming the gut wall),Capsicum Frutescens (Cayenne Fruits - igniting the digestive fire and stimulates contractions), Rhamnus Purshiana (Cascara Bark), Zingiber (Ginger Root - gentle contractor and prebiotic fibre), Allium Sativum (Garlic - aid sulphur pathways in the gut and a prebiotic to feed healthy gut bacteria), Cassia Angustifolia Fol (Senna Leaf - encourages softer stools and promotes contraction of the bowels), Cassia Angustifolia (Senna Pod - increase bile flow to support liver detox - encourage lubrication in the bowel and is a polyphenol to feed gut bacteria).",
    nutritional: "",
    description: "Powerful Gut Buster Supplement for Digestive Support Gut Buster capsules are designed to soften and move built-up sediment in your digestive tract. These effective gut buster pills promote healthy bowel movements and support good gut bacteria. Whether you call them gut buster tablets, gutbusters, or gutbuster capsules, this supplement helps reduce bloating, improve regularity, and support overall gut health. Trusted by users looking for natural digestive relief, Gut Buster is your go-to solution for a cleaner, healthier gut.",
    perDay: "from 56p a day · 50-day supply",
    blog: "/blog/unlock-your-bodies-natural-detox-potential-gutbuster",
    who: "Constipation and supporting detoxification pathways, Sluggish bowels, Feeling bloated or retaining water, To use with or alongside binders when on detoxification protocols",
    faq:[
      {question: "What does Gut Buster do?",
        answer:"Gut Buster is a powerful herbal blend designed to reignite natural gut contractions, support smooth and comfortable bowel movements, and restore your body’s natural digestive rhythm. It provides gentle, non-addictive support to help keep your bowels moving daily—an essential part of healthy detoxification.",
      },
      {question: "Is it safe?",
        answer:"Gut Buster is made from a carefully crafted blend of natural, traditionally used herbs and is described as gentle and non-addictive. As with any supplement, individual results may vary, and it’s recommended to consult a healthcare professional before beginning a new regimen.",
      },
      {question: "Can I take it daily?",
        answer:"Gut Buster is designed to support one to two healthy bowel movements per day, helping the body maintain its natural rhythm. Its gentle, non-addictive formulation makes it suitable for regular use as part of a gut-support routine.",
      },
      {question: "Will Gut Buster help with bloating?",
        answer:"Yes. Gut Buster can help with bloating by supporting regular bowel movements, improving digestive flow, and helping manage monthly hormonal sluggishness that often leads to bloating, brain fog, and inflammation.",
      },
      {question: "How long does it take to work?",
        answer:"The time it takes to feel results may vary, as the document does not specify an exact timeframe. Gut Buster works by supporting natural gut contractions and healthy elimination, so results typically appear as your digestive rhythm becomes more regular.",
      },
    ]
     },
  {
    id: "5",
    imageSrc: "/images/herbalBombs120.webp",
    title: "Herbal Bombs - Liver & Kidney Detox",
    size: "60 Capsules",
    slug: "herbal-bombs",
    faq: [
      {
        question: "What does Herbal Bombs support?",
        answer: "Your liver and kidney detoxification pathways. The blend is formulated to help flush out toxins, support healthy fluid balance and lift natural energy levels.",
      },
      {
        question: "How many capsules do I get?",
        answer: "60 capsules per pot.",
      },
    ],
    metaDescription: "Herbal capsules formulated to support liver and kidney detox pathways, healthy fluid balance and natural energy. A gentle daily cleanse. 60 capsules.",
    who: "Anyone wanting to support liver and kidney detox pathways, People who feel bloated or are retaining fluid, Those resetting after a period of poor diet or low energy, Anyone looking for a gentle daily cleanse",
    price: "£30.00 GBP",
    tagline: "Gentle daily cleanse for lighter, clearer, more balanced energy",
    tags: ["Detox", "Gut Health"],
    trust: [{label: "Supports Liver & Kidney Detox"}, {label: "Promotes Healthy Fluid Balance"}, {label: "Boosts Natural Energy"}],
    directions: "",
    ingredients: "",
    nutritional: "",
    description:
      "Support your body’s natural detox pathways with our Liver & Kidney Detox Support blend. Formulated to gently cleanse and rejuvenate, this herbal remedy helps flush out toxins, reduce bloating, and boost energy levels. Perfect for those looking to reset their system and feel lighter, clearer, and more balanced from within. 🌿 Supports liver and kidney detoxification 💧 Promotes healthy fluid balance and toxin removal ⚡ Helps increase natural energy and vitality",
  },
  {
    id: "6",
    imageSrc: "/images/magicClay120.webp",
    title: "Magic Clay - Bentonite & Charcoal Detox",
    size: "100 Capsules",
    slug: "magic-clay",
    faq: [
      {
        question: "How do I take Magic Clay?",
        answer: "Take 2–4 capsules with half a pint of water, either before bed or on rising.",
      },
      {
        question: "Can I take it alongside my other supplements or medication?",
        answer: "Take Magic Clay 40 minutes away from food, supplements or medications.",
      },
      {
        question: "What's in it?",
        answer: "Licorice root, slippery elm bark, fennel seed and fenugreek seed powders, bentonite clay, activated charcoal and apple pectin, in vegetarian capsules.",
      },
      {
        question: "How long does a pot last?",
        answer: "There are 100 capsules per pot, so at 2–4 capsules a day that's roughly 25 to 50 days depending on the dose you settle on.",
      },
    ],
    metaDescription: "Bentonite clay and activated charcoal capsules that bind toxins and heavy metals while supporting digestion and clearer skin. 100 capsules, \u00a330.",
    who: "Anyone doing an occasional cleanse or detox protocol, People wanting to bind toxins and heavy metals, Those supporting digestive balance and gut health, Anyone looking for clearer skin and steadier energy",
    price: "£30.00 GBP",
    perDay: "from 56p a day · 50-day supply",
    tagline: "Dual-action cleanse with clay + charcoal—binds toxins and supports gut & skin",
    tags: ["Detox", "Gut Health"],
    trust: [{label: 'Binds Toxins & Heavy Metals'}, {label: 'Supports Digestive Health'}, {label: 'Promotes Clearer Skin & Energy'}],
    directions: "Take 2–4 capsules with 1/2 pint of water before bed or on rising. Take 40 minutes away from food, supplements or medications.",
    ingredients: "Glycyrrhiza Glabra (licorice root) Powder, Ulmus Fulva (slippery elm bark) Powder, Foeniculum Vulgare (fennel seed) Powder, Trigonella Foenum-Graecum (fenugreek seed) Powder, Bentonite Clay, Activated Charcoal, Apple Pectin Powder, Vegetarian Capsules.",
    nutritional: "",
    description:
      "This powerful detox blend combines Bentonite Clay and Activated Charcoal to help bind and eliminate toxins and heavy metals from the body. Together, they support deep internal cleansing, promote gut health, and assist the body’s natural detoxification process. Ideal for occasional cleanses or as part of your daily wellness routine. 🌿 Supports digestive balance and toxin removal 🖤 Binds heavy metals and harmful substances 💪 Promotes clearer skin, improved energy, and gut health.",
  },
  {
    id: "7",
    imageSrc: "/images/CacoaGetUpGo.webp",
    title: "Get Up & Go Cacao - Mushroom Energy Blend",
    size: "300g",
    slug: "cacoa",
    faq: [
      {
        question: "How do I use Get Up & Go Cacao?",
        answer: "Blend it with your milk of choice, or add nuts or nut butter for extra protein, avocado or MCT for good fats. You can also sprinkle it over yoghurt with organic berries.",
      },
      {
        question: "Does it contain caffeine?",
        answer: "There is some natural caffeine from the matcha in the blend. It's balanced with adaptogens, medicinal mushrooms and prebiotic fibre, which is what gives it steady energy rather than a spike and a crash.",
      },
      {
        question: "What's in it?",
        answer: "Cacao, black maca, matcha, D-ribose, cordyceps and lion's mane mushrooms, PHGG prebiotic fibre (SIBO sensitive) and ginkgo biloba.",
      },
      {
        question: "How many servings are in a bag?",
        answer: "The bag is 300g, which works out at roughly 20 to 30 servings.",
      },
    ],
    metaDescription: "Raw cacao with lion's mane, cordyceps, black maca and matcha for clean, steady focus without the caffeine crash \u2014 plus SIBO-friendly prebiotic fibre.",
    who: "Anyone wanting focus and mental clarity without a caffeine crash, People who find coffee too stimulating, Those supporting a healthy gut microbiome alongside their energy, Anyone wanting adaptogens and prebiotic fibre in one morning drink",
    price: "£30.00 GBP",
    perDay: "approx 20–30 servings",
    badge: "Best Seller",
    tagline: "Clean brain + body fuel—focus, steady energy, and gut support",
    tags: ["Focus", "Hormones"],
    trust: [{label: "Supports focus and mental clarity"}, {label: "Steady, jitter-free energy"}, {label: "Prebiotics for gut health"}],
    directions: "Blend solely with your chosen milk or blend with nuts/nut butter for extra protein, avocado or MCT for good fats. Alternatively sprinkle on yoghurt with organic berries.",
    ingredients: "Cacao, Black Maca, Matcha, D-Ribose, Cordyceps & Lion’s Mane Mushrooms, PHGG (SIBO sensitive fibre), Ginkgo Biloba.",
    nutritional: "Adaptogenic herbs to naturally balance hormones, support thyroid and metabolism, increase cellular energy, feed the gut & brain, & help balance blood sugar levels and reduce cravings.",
    description:
      "Fuel your body and mind naturally with a premium organic blend of medicinal mushrooms, raw cacao, prebiotics, and nootropic herbs. Designed to deliver a clean, sustained energy boost, this powerful superfood formula supports mental clarity, focus, and cognitive performance, while promoting a healthy gut microbiome. Whether you’re seeking to improve brain function, reduce stress, or optimise digestive wellness, this all-natural formula supports your daily well-being without the crash of caffeine or synthetic stimulants.",
  },
  {
    id: "8",
    imageSrc: "/images/calmingCacao.webp",
    title: "Calming Cacao - Reishi & Ashwagandha Blend",
    size: "300g",
    slug: "calming-cacoa",
    faq: [
      {
        question: "How do I make it?",
        answer: "Blend 1–2 tablespoons with your milk of choice, heat it up and stir. A drop of vanilla paste sweetens it if you want it sweeter.",
      },
      {
        question: "How is this different from Get Up & Go Cacao?",
        answer: "Get Up & Go is the morning blend, built for focus and energy. Calming Cacao does the opposite — it's for the evening, and it's the one to reach for if you find Get Up & Go too uplifting first thing.",
      },
      {
        question: "What's in it?",
        answer: "Cacao, reishi mushrooms, red maca, ashwagandha, avena sativa, Montmorency cherry tart and PHGG prebiotic fibre powder (SIBO sensitive).",
      },
      {
        question: "How many servings are in a bag?",
        answer: "The bag is 300g — approximately 30 servings, or about £1 a cup.",
      },
    ],
    metaDescription: "Raw cacao with reishi, ashwagandha and red maca to calm the nervous system and support restful sleep. The evening answer to Get Up & Go. 300g.",
    who: "Anyone winding down in the evening, People who find Get Up & Go too uplifting in a morning, Those supporting relaxation and restful sleep naturally, Anyone wanting a chocolate-tasting evening drink",
    price: "£30.00 GBP",
    perDay: "from £1 a cup · approx 30 servings",
    tags: ["Sleep", "Hormones"],
    trust: [{label: "Supports Relaxation & Calm"}, {label: "Evening friendly and caffeine-free"}, {label: "Organic cacao & adaptogens"}],
    directions: "Blend 1–2 tbs with your chosen milk, heat up, stir and enjoy. To sweeten add a drop of vanilla paste .",
    ingredients: "Cacao, Reishi Mushrooms, Red Maca, Ashwagandha, Avena Sativa, Montara Cherry Tart, PHGG prebiotic fibre powder (SIBO sensitive).",
    nutritional: "Adaptogenic herbs to naturally balance hormones, calm the nervous system, promote sleep, feed the gut & brain & help balance blood sugars.",
    tagline: "Chocolatey calm for the evening—unwind, relax, and rest easier",
    description:
      "Calming Cacao is a combination of raw cacao and well researched adaptogens to help calm the nervous system and aid the production of serotonin to support melatonin. This really enjoyable chocolate tasting drink is a must in the evenings or for those that find Get Up and Go too uplifting in a morning. All Organic Ingredients: Cacao, Red Maca, Ashwagandha, Reishi Mushroom, Montmorency Cherry Tart, Avena Sativa, Triphala Digestive Enzymes, PHGG.",
  }
]);
